import React, { useEffect, useState } from "react";
import { CardBody, TabContent, Table, TabPane } from "reactstrap";
import axiosInstance from "../../../Utils/axiosInstance";
import { backendbaseUrl } from "../../../Utils/baseUrl";
import { Form, FormGroup, Input, Label } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { toast } from "react-toastify";
import { flagIconData } from "../../../Data/Icons/FlagIcons";
import { Key } from "react-feather";

const LS_KEY = "countries_rows_per_page";

interface MaterialStyleContentProps {
  tabId: string;
  filter: string;
}

export default function MaterialStyleContent({
  tabId,
  filter,
}: MaterialStyleContentProps) {
  const [countries, setCountries] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedCountry, setSelectedCountry] = useState<any | null>(null);
  const [modal, setModal] = useState(false);
  const [checkedCountries, setCheckedCountries] = useState<{
    [key: string]: boolean;
  }>({});
  const [countryName, setCountryName] = useState("");
  const [countryCode, setCountryCode] = useState("");

  const [currencyName, setCurrencyName] = useState("");
  const [currencyCode, setCurrencyCode] = useState("");
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [contriId, setContriId] = useState(null);

  const [containerReRender, setContainerReRender] = useState(0);
  const [isRefreshDefault, setIsRefreshDefault] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState<number>(() => {
    const saved = localStorage.getItem(LS_KEY);
    return saved ? Number(saved) : 10;
  });
// Helper function to standardize country names
  const standardizeCountryName = (name: string) => {
    if (!name) return name;
  // If comma exists, prefer the part before the comma if it's short, else swap
    if (name.includes(",")) {
      const [main, rest] = name.split(",");
    // If main part is short (<= 12 chars), just use it (e.g. "Bolivia")
      if (main.trim().length <= 12) return main.trim();
    // Otherwise, swap order
      return `${rest.trim()} ${main.trim()}`;
    }
    return name;
  };
  useEffect(() => {
    const fetchData = async () => {
      let isActive = tabId === "1" ? "false" : "true";

      try {
        const response = await axiosInstance.get(
          `${backendbaseUrl}/users/countries/?is_active=${isActive}`
        );

        const data = response.data;
      console.log("API Response:", data);

      // Standardize country names in the API response
        const standardizedCountries = (data.country_details || []).map((item: any) => ({
          ...item,
          country: {
            ...item.country,
            country_name: standardizeCountryName(item.country?.country_name),
          },
        }));

        setCountries(standardizedCountries);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, [tabId, containerReRender, isRefreshDefault]);
  // useEffect(() => {
  //   const fetchData = async () => {
  //     let isActive = tabId === "1" ? "false" : "true";

  //     try {
  //       const response = await axiosInstance.get(
  //         `${backendbaseUrl}/users/countries/?is_active=${isActive}`
  //       );

  //       const data = response.data;
  //       console.log("API Response:", data);

  //       setCountries(data.country_details || []);
  //       setLoading(false);
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, [tabId, containerReRender, isRefreshDefault]);

    useEffect(() => {
    setCurrentPage(1);
  }, [filter, tabId]);


const filteredCountries = countries.filter((i) =>
  i.country?.country_name.toLowerCase().includes(filter.toLowerCase()) ||
  i.country?.country_code.toLowerCase().includes(filter.toLowerCase())
);
  const totalRows = filteredCountries.length;
  const totalPages = Math.ceil(totalRows / rowsPerPage);
  const paginatedCountries = filteredCountries.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  const startRow = totalRows === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1;
  const endRow = Math.min(currentPage * rowsPerPage, totalRows);

  const toggleModal = (country: any) => {
    console.log(country);
    setSelectedCountry(country);
    setCountryName(country.country?.country_name || "");
    setCountryCode(country.country?.country_code || "");
    setCurrencyName(country?.currency_name || "");
    setCurrencyCode(country?.currency_code || "");
    setCurrencySymbol(country?.currency_symbol || "");
    setContriId(country?.id || "");

    setCheckedCountries((prev) => ({
      ...prev,
      [country.country?.country_name]: true,
    }));
    setModal(true);
  };
  const defaultHandler = async (id: number) => {
    try {
      const response = await axiosInstance.patch(
        `${backendbaseUrl}/users/update-default-country-details/${id}`,


      );

      console.log(response);
      if (response.status === 200) {
        toast.success("Updated successfully");
        setIsRefreshDefault(!isRefreshDefault)

      }
    } catch (error: any) {


    }
  };

  const closeModal = () => {
    if (selectedCountry) {
      setCheckedCountries((prev) => ({
        ...prev,
        [selectedCountry.country?.country_name]: false,
      }));
    }
    setModal(false);
    setSelectedCountry(null);
    setCountryName("");
    setCountryCode("");
    setCurrencyName("");
    setCurrencyCode("");
    setCurrencySymbol("");
  };

  const handleDeactivate = async (id: number) => {
    try {
      const response = await axiosInstance.patch(
        `${backendbaseUrl}/users/country-toggle-details/${id}`,
        { is_active: false }
      );

      if (response.status === 200) {
        toast.success("Deactivated successfully");
        setContainerReRender((prev) => prev + 1); // Trigger re-render
      } else {
        toast.warning("Something went wrong, please try again");
      }
    } catch (error: any) {
      console.error("Error deactivating:", error);
      toast.error("Failed to deactivate. Please try again.");
    }
  };

  const handleSubmit = () => {
    if (countryName.trim() === "") {
      toast.error("Country Name cannot be empty");
      return false;
    } else if (countryCode.trim() === "") {
      toast.error("Country Code cannot be empty");
      return false;
    } else if (currencyName.trim() === "") {
      toast.error("Currency Name cannot be empty");
      return false;
    } else if (currencyCode.trim() === "") {
      toast.error("Curency Code cannot be empty");
      return false;
    } else if (currencySymbol.trim() === "") {
      toast.error("Currency Symbol cannot be empty");
      return false;
    } else {
      console.log("Country Name:", countryName);
      console.log("Country Code:", countryCode);
      console.log("Currency Name:", currencyName);
      console.log("Currency Code:", currencyCode);
      console.log("Currency Symbol:", currencySymbol);
    }

    const formData = {
      currency_name: currencyName,
      currency_code: currencyCode,
      currency_symbol: currencySymbol,
      is_active: true,
    };

    const apiResponse = async () => {
      try {
        const response = await axiosInstance.patch(
          `${backendbaseUrl}/users/country-toggle-details/${contriId}`,
          formData
        );
        if (response.status === 200) {
          toast.success("Activated Successfully");
          setContainerReRender(containerReRender + 1);
          console.log(containerReRender, "containerReRender");
          closeModal();
        } else {
          toast.warning("Something went wrong, please try again");
        }
        console.log(response.status, "edited");
      } catch (error: any) {
        console.error("Error updating details:", error);

        // Show a toast error message
        if (error.response) {
          // Server responded with a status other than 2xx
          toast.error(
            `Failed to update: ${error.response.status} - ${error.response.data?.message || "Unknown error"
            }`
          );
        } else if (error.request) {
          // No response received
          toast.error("No response from server. Please check your connection.");
        } else {
          // Something else happened
          toast.error("An unexpected error occurred. Please try again.");
        }
      }
    };

    apiResponse();
  };

  return (
    <>
      <TabContent activeTab={tabId}>
        <CardBody className="px-0 pb-0 pt-3">
          <TabPane className="fade show" tabId={tabId}>
            {loading ? (
              <p>Loading data...</p>
            ) : (
              <div className="user-content">
                <div className="table-responsive">
                  <Table className="mb-0">
                    <thead>
                      <tr>
                        <th className="table-th">Sl.No</th>
                        <th className="table-country-name">Country Name</th>
                        <th className="table-country-code">Country Codes</th>
                        <th className="table-enable-disable">Enable/Disable</th>
                        <th className="table-enable-disable">
                          {tabId === "2" && "Default"}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedCountries.length > 0 ? (
                        paginatedCountries.map((i, index) => {
                          const countryAbbreviation = i.country?.country_code?.toLowerCase();
                          const globalIndex = (currentPage - 1) * rowsPerPage + index + 1;

                          return (
                            <tr key={index}>
                              <td className="table-th">{globalIndex}</td>
                              <td className="table-country-name">
                                <div className="d-flex align-items-center">
                                  {/* Display the flag icon */}

                                  {i.country?.country_name || "N/A"}
                                </div>
                              </td>
                              <td className="table-country-code">
                                <span className="flag">
                                  {countryAbbreviation && (
                                    <i
                                      className={`flag-icon fi fi-${countryAbbreviation}`}
                                    />
                                  )}
                                </span>

                                {i.country?.country_code || "N/A"}
                              </td>
                              <td className="table-enable-disable">
                                <div className="align-items-center d-flex gap-1">
                                  <Form>
                                    <FormGroup switch>
                                      <Input
                                        type="switch"
                                        checked={i.is_active}
                                        onChange={() => {
                                          if (!i.is_active) {
                                            toggleModal(i);
                                          } else {
                                            handleDeactivate(i.id);
                                          }
                                        }}
                                      />
                                    </FormGroup>
                                  </Form>
                                </div>
                              </td>
                              {i.is_active && (
                                <td className="table-enable-disable default">
                                  <div className="align-items-center d-flex gap-1">
                                    <Form>
                                      <FormGroup switch>
                                        <Input
                                          type="switch"
                                          checked={i.is_default}
                                          onChange={() => defaultHandler(i.id)}
                                        />
                                      </FormGroup>
                                    </Form>
                                  </div>
                                </td>
                              )}
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={4} className="text-center">
                            {tabId === "1"
                              ? "No inactive countries found."
                              : "No active countries found."}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>

                  <div className="rdt_Pagination d-flex align-items-center justify-content-end px-3 py-2"
                    style={{ fontSize: "13px", borderTop: "1px solid #e0e0e0" }}>

                    <span className="me-2">Rows per page:</span>
                    <select
                      className="me-4"
                      style={{ border: "none", fontSize: "13px", outline: "none", cursor: "pointer" }}
                      value={rowsPerPage}
                      onChange={(e) => {
                        const val = Number(e.target.value);
                        setRowsPerPage(val);
                        localStorage.setItem(LS_KEY, String(val));
                        setCurrentPage(1);
                      }}                    >
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                    </select>

                    <span className="me-3">{startRow}-{endRow} of {totalRows}</span>

                    <div className="d-flex gap-1">
                      <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
                        style={{ border: "none", background: "none", cursor: currentPage === 1 ? "not-allowed" : "pointer", opacity: currentPage === 1 ? 0.3 : 1, fontSize: "16px" }}>
                        {"⟪"}
                      </button>
                      <button onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} disabled={currentPage === 1}
                        style={{ border: "none", background: "none", cursor: currentPage === 1 ? "not-allowed" : "pointer", opacity: currentPage === 1 ? 0.3 : 1, fontSize: "16px" }}>
                        {"‹"}
                      </button>
                      <button onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages || totalPages === 0}
                        style={{ border: "none", background: "none", cursor: (currentPage === totalPages || totalPages === 0) ? "not-allowed" : "pointer", opacity: (currentPage === totalPages || totalPages === 0) ? 0.3 : 1, fontSize: "16px" }}>
                        {"›"}
                      </button>
                      <button onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages || totalPages === 0}
                        style={{ border: "none", background: "none", cursor: (currentPage === totalPages || totalPages === 0) ? "not-allowed" : "pointer", opacity: (currentPage === totalPages || totalPages === 0) ? 0.3 : 1, fontSize: "16px" }}>
                        {"⟫"}
                      </button>
                    </div>
                  </div>
              </div>
            )}
          </TabPane>
        </CardBody>
      </TabContent>

      <Modal isOpen={modal} centered toggle={closeModal}>
        <ModalHeader toggle={closeModal}>
          {selectedCountry?.country?.country_name || "Country Details"}
        </ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label for="countryName">Country Name</Label>
              <Input
                id="countryName"
                type="text"
                value={countryName}
                onChange={(e) => setCountryName(e.target.value)}
              />
            </FormGroup>
            <FormGroup>
              <Label for="countryCode">Country Code</Label>
              <Input
                id="countryCode"
                type="text"
                value={countryCode}
                onChange={(e) => setCountryCode(e.target.value)}
              />
            </FormGroup>
            <FormGroup>
              <Label for="currencyName">Currency Name</Label>
              <Input
                id="currencyName"
                type="text"
                value={currencyName}
                onChange={(e) => setCurrencyName(e.target.value)}
              />
            </FormGroup>
            <FormGroup>
              <Label for="currencyCode">Currency Code</Label>
              <Input
                id="currencyCode"
                type="text"
                value={currencyCode}
                onChange={(e) => setCurrencyCode(e.target.value)}
              />
            </FormGroup>
            <FormGroup>
              <Label for="currencySymbol">Currency Symbol</Label>
              <Input
                id="currencySymbol"
                type="text"
                value={currencySymbol}
                onChange={(e) => setCurrencySymbol(e.target.value)}
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSubmit}>
            Submit
          </Button>
          <Button color="secondary" onClick={closeModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}
